export default "__VITE_ASSET__1d0324ea__"